import React from "react";
import "./SeleccionOjo.css";

const SeleccionOjo = ({ imgSeleccion, onSeleccionar, className = "" }) => {
  return (
    <div className={`test-container ${className}`}>
      <img
        src={imgSeleccion}
        alt="seleccion ojo"
        className="img-seleccion-ojo"
      />
      <div className="seleccion-ojo">
        <p>Selecciona el ojo con el cuál deseas comenzar el test</p>
        <p>Una vez seleccionado, cubre el ojo opuesto para iniciar el test</p>
        <div className="botones-ojo">
          <button
            onClick={() => onSeleccionar("izquierdo")}
            className="btn-ojo"
          >
            Izquierdo
          </button>
          <button onClick={() => onSeleccionar("derecho")} className="btn-ojo">
            Derecho
          </button>
        </div>
      </div>
    </div>
  );
};

export default SeleccionOjo;